// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"6af578b7","213":"8244ad9c","417":"537339df","420":"312f5c95","448":"b08be6b5","566":"48afa0b1","586":"dacf5a53","631":"8a0b7267","664":"4e6d7e82","908":"ec3cba9a","910":"740ce3ed","972":"1cdd7c8d","984":"e6bf80fb"}[chunkId] + ".chunk.js";
};